import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function TransformationSection() {
  return <Section className="bg-[#FDF8F3]" data-id="element-178">
      <FadeIn data-id="element-179">
        <div className="text-center max-w-2xl mx-auto" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] mb-8" data-id="element-181">
            Qué cambia en 7 días
          </h2>
          <p className="text-lg text-[#2D2A26]/70 mb-8" data-id="element-182">
            No te voy a decir “vida perfecta”. Te voy a decir lo real:
          </p>

          <div className="space-y-4 text-left inline-block" data-id="element-183">
            <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#E8872B]/10" data-id="element-184">
              <span className="text-2xl" data-id="element-185">😌</span>
              <span className="text-lg font-medium text-[#2D2A26]" data-id="element-186">
                Dejas de entrar a tu casa con duda
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#E8872B]/10" data-id="element-187">
              <span className="text-2xl" data-id="element-188">🌿</span>
              <span className="text-lg font-medium text-[#2D2A26]" data-id="element-189">
                Dejas de poner aromatizante por nervios
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#E8872B]/10" data-id="element-190">
              <span className="text-2xl" data-id="element-191">🧹</span>
              <span className="text-lg font-medium text-[#2D2A26]" data-id="element-192">
                Dejas de trapear para “calmar la culpa”
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#E8872B]/10" data-id="element-193">
              <span className="text-2xl" data-id="element-194">🎯</span>
              <span className="text-lg font-medium text-[#2D2A26]" data-id="element-195">
                Empiezas a saber exactamente qué tocar cuando el olor intenta
                volver
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}